export default function({
    settings = {},
    name,
    onChange,
    disabled
}) {

    return [
        {
            type: "Switch",
            data: {
                value: settings[name] || false,
                onChange,
                disabled
            }
        }
    ]
}